import {Component, OnDestroy, OnInit} from '@angular/core';
import {BusyService} from './services/busy.service';
import {GoogleTagService} from '../../../shared/src/lib/services/google-tag.service';
import {ActivatedRoute, NavigationEnd, Router, Scroll} from '@angular/router';
import {filter, Subscription} from 'rxjs';
import {
    NgcCookieConsentService,
    NgcInitializationErrorEvent,
    NgcInitializingEvent,
    NgcNoCookieLawEvent,
    NgcStatusChangeEvent
} from 'ngx-cookieconsent';
import {ViewportScroller} from '@angular/common';
import {environment} from '../environments/environment';
import {DataService} from '../../../firebase/src/lib/services/data.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
    title = 'anima';
    loading = true;
    hideNav = false;

    private popupOpenSubscription!: Subscription;
    private popupCloseSubscription!: Subscription;
    private initializingSubscription!: Subscription;
    private initializedSubscription!: Subscription;
    private initializationErrorSubscription!: Subscription;
    private statusChangeSubscription!: Subscription;
    private revokeChoiceSubscription!: Subscription;
    private noCookieLawSubscription!: Subscription;

    constructor(
        private busy: BusyService,
        private gtService: GoogleTagService,
        private data: DataService,
        private cookieService: NgcCookieConsentService,
    ) {
    }

    ngOnInit() {
        this.data.getLatestResultId();

        if (environment.production) {
            this.gtService.addGtmToDom()
                .then();
        }
        this.busy.isBusy().subscribe((res) => {
            this.loading = res;
        });
        // subscribe to cookieconsent observables to react to main events
        this.popupOpenSubscription = this.cookieService.popupOpen$.subscribe(
            () => {
                // you can use this.cookieService.getConfig() to do stuff...
            });

        this.popupCloseSubscription = this.cookieService.popupClose$.subscribe(
            () => {
                // you can use this.cookieService.getConfig() to do stuff...
            });

        this.initializingSubscription = this.cookieService.initializing$.subscribe(
            (event: NgcInitializingEvent) => {
                // the cookieconsent is initilializing... Not yet safe to call methods like `NgcCookieConsentService.hasAnswered()`
            });

        this.initializedSubscription = this.cookieService.initialized$.subscribe(
            () => {
                // the cookieconsent has been successfully initialized.
                // It's now safe to use methods on NgcCookieConsentService that require it, like `hasAnswered()` for eg...
            });

        this.initializationErrorSubscription = this.cookieService.initializationError$.subscribe(
            (event: NgcInitializationErrorEvent) => {
                // the cookieconsent has failed to initialize...
            });

        this.statusChangeSubscription = this.cookieService.statusChange$.subscribe(
            (event: NgcStatusChangeEvent) => {
                // you can use this.cookieService.getConfig() to do stuff...
            });

        this.revokeChoiceSubscription = this.cookieService.revokeChoice$.subscribe(
            () => {
                // you can use this.cookieService.getConfig() to do stuff...
            });

        this.noCookieLawSubscription = this.cookieService.noCookieLaw$.subscribe(
            (event: NgcNoCookieLawEvent) => {
                // you can use this.cookieService.getConfig() to do stuff...
            });
    }

    ngOnDestroy() {
        // unsubscribe to cookieconsent observables to prevent memory leaks
        this.popupOpenSubscription.unsubscribe();
        this.popupCloseSubscription.unsubscribe();
        this.initializingSubscription.unsubscribe();
        this.initializedSubscription.unsubscribe();
        this.initializationErrorSubscription.unsubscribe();
        this.statusChangeSubscription.unsubscribe();
        this.revokeChoiceSubscription.unsubscribe();
        this.noCookieLawSubscription.unsubscribe();
    }

    navbarScroll() {
        const y = window.scrollY;
        if (y > 600) {
            const header = document.getElementsByClassName('header')[0];
            if (header) {
                header.classList.add('small');
            }

        } else if (y < 600) {
            const header = document.getElementsByClassName('header')[0];
            if (header) {
                header.classList.remove('small');
            }
        }
    }

}
